import { Badge, BadgeProps, Flex, SkeletonText, Td } from '@chakra-ui/react';
import TableRow from 'components/TableRow';
import IconAction from 'containers/IconAction';
import React from 'react';
import { getBadgeColor, getStatusLabel } from 'utils/statusHelpers';

interface FileStatusRowProps {
    label: string;
    type: 'antiVirus' | 'decryption' | 'validation'; // APEX-1151: Add validation type
    status?: string;
    isLoading: boolean;
}

// Wrapper to avoid complex union type issues with Chakra UI's Badge component
const StatusBadge = ({
    type,
    status
}: {
    type: 'antiVirus' | 'decryption' | 'validation'; // APEX-1151: Add validation type
    status?: string
}) => {
    const colorScheme = getBadgeColor(type, status);
    const label = getStatusLabel(type, status);

    // Type assertion to bypass Chakra UI's complex union type (TS2590)
    // This is safe because getBadgeColor only returns valid color schemes
    return <Badge colorScheme={colorScheme as any}>{label}</Badge>;
};

const FileStatusRow: React.FC<FileStatusRowProps> = ({
    label,
    type,
    status,
    isLoading,
}) => {
    return (
        <TableRow>
            <Td>
                <Flex align="center" gap={3}>
                    {label}
                    {/* APEX-1151: Skip IconAction for validation type (no icon needed) */}
                    {type !== 'validation' && (
                        <IconAction
                            isLoading={isLoading}
                            antiVirusStatus={type === 'antiVirus' ? status : undefined}
                            decryptionStatus={type === 'decryption' ? status : undefined}
                            type={type}
                        />
                    )}
                </Flex>
            </Td>
            <Td>
                {isLoading ? (
                    <SkeletonText noOfLines={1} width="70px" />
                ) : (
                    <StatusBadge type={type} status={status} />
                )}
            </Td>
        </TableRow>
    );
};

export default FileStatusRow;
